import { OperatorFunction, scan } from 'rxjs';
import { IMessage } from '../data/message';
import { MessageEvent } from '../data/message-event';

/**
 * @returns
 * An operator that takes a stream of message events as a source
 * and that emits the messages which should be visible.
 */
export function collectMessages<T extends IMessage>(): OperatorFunction<
  MessageEvent<T>,
  T[]
> {
  return scan((acc, { message, type }) => {
    const indexInOpen = acc.findIndex(({ key }) => key === message.key);

    switch (type) {
      case 'open':
        // In case that the modal isn't already shown, add it
        if (indexInOpen === -1) {
          return [...acc, { ...message }];
        }
        // If the modal is already shown, replace it
        acc[indexInOpen] = { ...message };
        return acc;
      case 'close':
        return indexInOpen === -1
          ? acc
          : acc.filter((_, i) => i !== indexInOpen);
      default:
        return acc;
    }
  }, [] as T[]);
}
